export const DEFAULT_PRIME_INPUT_TEXT_MAX_LENGTH = 200;
export const DEFAULT_PRIME_TEXTAREA_MAX_LENGTH = 500;
